import type { CSSObject } from '@emotion/react'
import { Color, Spacing, Typeface, Typography } from '@opallabs/gem'
import type { StyleProps } from './types'

export const container = ({ theme }: StyleProps): CSSObject => ({
  color: Color[theme].Text.Gray,
  display: 'flex',
  flexDirection: 'column',
  fontFamily: Typeface.Default,

  '@media (prefers-contrast: more)': {
    color: Color[theme].Text.Default,
  },
})

export const content: CSSObject = {
  alignItems: 'center',
  display: 'flex',
  justifyContent: 'space-between',
}

export const meter: CSSObject = {
  // Historically this was hardcoded as 155 px, in a 239 px-wide container,
  // so ≃64.9%.
  maxInlineSize: '65%',
}

export const text: CSSObject = {
  ...Typography.M500,
  fontSize: Typography.T300.fontSize,
  display: 'flex',
  marginInlineStart: Spacing.S * 1.5,
}

export const tooltipText: CSSObject = {
  ...Typography.T300,

  // resets
  textAlign: 'start',
  textTransform: 'none',
}
